import React from "react"
import "../../assets/scss/custom/components/_CustomSpinner.scss"

const CustomSpinner = () => {
  return <div className="spinner"></div>
}

export default CustomSpinner
